const stripBraces = (dyno) => dyno.replace(/^\{\{|\}\}$/g, '').trim();

// Reuses clean()'s original character set, applied only to the path portion
const sanitizePath = (path) => path.replace(/[&/\\#,+()$~%'":*?<>{}]/g, '').trim();

const FILTER_ALIASES = {
	upper: 'upperCase',
	lower: 'lowerCase',
	title: 'titleCase',
	sentence: 'sentenceCase',
	camel: 'camelCase',
};

const parseFilterSpec = (filterSpec) => {
	const parts = filterSpec.split(':');
	const raw = parts[0].trim();
	const name = FILTER_ALIASES[raw] || raw;
	if (!name) {
		return null;
	}
	const args = parts.slice(1).map((a) => a.trim().replace(/^["']|["']$/g, ''));
	return { name, args };
};

/**
 * Parses a DynoMark tag (e.g. `{{user.name | upperCase}}`) into its path and filter list.
 * @param {string} dyno - a full `{{...}}` tag string
 * @returns {{ path: string, filters: Array<{ name: string, args: string[] }> }}
 */
const parseDynoTag = (dyno) => {
	const inner = stripBraces(dyno);
	if (!inner) {
		return { path: '', filters: [] };
	}

	// Split on pipes but do NOT filter before indexing — a leading '|' means empty path
	const rawParts = inner.split('|');
	const path = sanitizePath(rawParts[0].trim());
	const filters = rawParts.slice(1)
		.map((s) => s.trim())
		.filter(Boolean)
		.map(parseFilterSpec)
		.filter(Boolean);

	return { path, filters };
};

export default parseDynoTag;
